import type { QueryParameterConfig } from '@pba/react-router';
import { type GiveTransactionResult, isGiveTransactionResult } from 'features/transactions';

// eslint-disable-next-line @typescript-eslint/naming-convention -- need to be renamed to not eslint error
export const TransactionResultParameter = {
  decode(value?: Array<null | string> | null | string) {
    if (isGiveTransactionResult(value)) {
      return value;
    }

    return undefined;
  },

  default: undefined,
  encode(value?: GiveTransactionResult) {
    return value;
  },
} satisfies QueryParameterConfig<GiveTransactionResult | undefined>;
